import { createSelector } from 'reselect';
import Immutable from 'immutable';
import { currentLibrarySelector } from './LibrarySelector';

export const allSites = state => state.getIn(['entities', 'sites']);

export const currentSiteScopes = createSelector(
  currentLibrarySelector,
  allSites,
  (library, sites) => sites.getIn([library.get('siteId').toString(), 'scopes'], Immutable.List.of(Immutable.Map()))
);



// WEBPACK FOOTER //
// ./app/selectors/ScopeSelector.js